<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card">
    <!-- 河川予警報情報一覧 -->
    <v-row
      v-if="numberRiverWarns > 0 && firstEmergency"
      align="center"
      class="card_content tm-pc-detail-info ma-0 pa-0"
    >
      <v-list
        class="tm-pc-detail-info-rw-info pa-0"
        :class="jadgeKnd(firstEmergency).backgroundClass"
      >
        <v-list-group
          no-action
          :append-icon="numberRiverWarns > 1 ? undefined : ''"
        >
          <template v-slot:activator>
            <v-list-item class="pa-0">
              <v-btn
                small
                rounded
                depressed
                color="red white--text"
                v-if="numberRiverWarns > 1"
                >{{ numberRiverWarns }}</v-btn
              >
              <v-list-item-content class="ml-2 pa-0">
                <v-list-item-subtitle>
                  <span class="list-rw-info-white-space">
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn"
                      >{{ jadgeTitle(firstEmergency.type) }}</span
                    >
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn ml-1"
                      >{{ firstEmergency.kndNm }}</span
                    >
                    <span
                      class="ml-2"
                      :class="jadgeKnd(firstEmergency).textClass"
                      >{{ getDateText(firstEmergency) }}</span
                    >
                    <span
                      class="ml-2"
                      :class="jadgeKnd(firstEmergency).textClass"
                      >{{ firstEmergency.name }}</span
                    >
                    <span
                      class="ml-2"
                      :class="jadgeKnd(firstEmergency).textClass"
                      >{{ firstEmergency.heading }}</span
                    >
                    <span>
                      <v-btn
                        class="ml-2 mb-1"
                        color="primary"
                        @click="clickRiverWarnList(firstEmergency)"
                        max-height="24"
                        v-if="firstEmergency.attchFlg == 1"
                      >
                        <span>{{ text.btn }}</span>
                      </v-btn>
                    </span>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div v-if="typeof listRw !== 'undefined'">
            <v-list-item
              class="tm-pc-detail-info-rw-info"
              v-for="(info, index) in listRw"
              :key="index"
              :class="jadgeKnd(info).backgroundClass"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-subtitle>
                  <span class="list-rw-info-white-space">
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn"
                      >{{ jadgeTitle(info.type) }}</span
                    >
                    <span
                      class="tm-pc-text-detail-info-icon tm-pc-detail-info-rw-span-warn ml-1"
                      >{{ info.kndNm }}</span
                    >
                    <span class="ml-2" :class="jadgeKnd(info).textClass">{{
                      getDateText(info)
                    }}</span>
                    <span class="ml-2" :class="jadgeKnd(info).textClass">{{
                      info.name
                    }}</span>
                    <span class="ml-2" :class="jadgeKnd(info).textClass">{{
                      info.heading
                    }}</span>
                    <v-btn
                      class="ml-2 mb-1"
                      color="primary"
                      @click="clickRiverWarnList(info)"
                      max-height="24"
                      v-if="info.attchFlg == 1"
                    >
                      <span>{{ text.btn }}</span>
                    </v-btn>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-group>
      </v-list>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]河川予警報カード
 * TmDetailRw.vue
 * @author ILUKE
 */

import Util from "./../../../lib/util";
import PageLog from "./../../../lib/pageLog.js";

export default {
  /** タグ名 */
  name: "tm-detail-rw",
  data() {
    return {
      /** 文字列リソース */
      text: {
        btn: "詳細表示",
        fldfrTitle: "洪水予報",
        evstgTitle: "水位周知",
        damdschTitle: "ダム放流通知",
        fldctlTitle: "水防警報",
      },
      /** 表示制御に使用する種別別情報 */
      kndInfo: [
        {
          backgroundClass: "tm-pc-detail-info-color-flood-occurrence",
          textClass: "tm-pc-detail-info-color-flood-occurrence-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-flood-danger",
          textClass: "tm-pc-detail-info-color-flood-danger-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-flood-refuge",
          textClass: "tm-pc-detail-info-color-flood-refuge-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-flood-warn",
          textClass: "tm-pc-detail-info-color-flood-warn-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-damdsch-disasteroperating",
          textClass: "tm-pc-detail-info-color-damdsch-disasteroperating-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-damdsch-riserving",
          textClass: "tm-pc-detail-info-color-damdsch-riserving-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-damdsch-normal",
          textClass: "tm-pc-detail-info-color-damdsch-normal-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-fldctl-dispatch",
          textClass: "tm-pc-detail-info-color-fldctl-dispatch-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-fldctl-preparation",
          textClass: "tm-pc-detail-info-color-fldctl-preparation-text",
        },
        {
          backgroundClass: "tm-pc-detail-info-color-fldctl-standby",
          textClass: "tm-pc-detail-info-color-fldctl-standby-text",
        },
        {
          backgroundClass: "tm-pc-detail-rw-info-other-color",
          textClass: "tm-pc-detail-rw-info-other-color-text",
        },
      ],
    };
  },
  mounted() {
    this.getObsRiverWarnRwInfo();
  },
  computed: {
    /** 河川予警報設定 */
    riverWarnConfig: {
      get() {
        return this.$store.state.RiverWarn.riverWarnConfig;
      },
    },
    /** 河川予警報件数 */
    numberRiverWarns: {
      get() {
        var info = this.$store.state.map.riverWarnInfo;
        return info.length;
      },
    },
    /** 河川予警報 緊急度が一番高い1件目 */
    firstEmergency: {
      get() {
        var info = this.$store.state.map.tmRwInfo;
        return info[0];
      },
    },
    /** 河川予警報一覧（緊急度が一番高い1件目を除く） */
    listRw: {
      get() {
        if (this.$store.state.map.riverWarnInfo) {
          return this.$store.state.map.riverWarnInfo.filter(
            (data) =>
              !(
                data.type == this.firstEmergency.type &&
                data.id == this.firstEmergency.id
              )
          );
        }
        return {};
      },
    },
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
  },
  methods: {
    /**
     * 河川予警報情報 取得
     */
    getObsRiverWarnInfo() {
      setTimeout(() => {
        this.$store.dispatch("map/getObsRiverWarnInfo", {
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
          isFldCtl: this.$store.getters["app/isFldCtl"],
          appTime: this.$store.state.app.appTimeRound,
        });
      }, 500);
    },
    /**
     * 河川予警報情報 緊急度が最も高い１件目 取得
     */
    getObsRwInfo() {
      setTimeout(() => {
        this.$store.dispatch("map/getObsRwInfo", {
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
          isFldCtl: this.$store.getters["app/isFldCtl"],
          appTime: this.$store.state.app.appTimeRound,
        });
      }, 500);
    },
    getObsRiverWarnRwInfo() {
      setTimeout(() => {
        this.$store.dispatch("map/getObsRiverWarnRwInfo", {
          ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
          itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
          obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
          isFldCtl: this.$store.getters["app/isFldCtl"],
          appTime: this.$store.state.app.appTimeRound,
        });
      }, 500);
    },
    /**
     * リストクリック
     */
    clickRiverWarnList(info) {
      if (info.id) {
        // アクセスログ出力
        let name = "";
        if (info.type == "fldfr") name = "fdfore_pdf";
        if (info.type == "evstg") name = "wlinfo_pdf";
        if (info.type == "fldctl") name = "fdcntl_pdf";
        if (info.type == "damdsch") name = "damdischa_pdf";
        PageLog.log({
          page_log: name,
          flood_cd: info.code,
          flood_no: info.annNo,
          device_sb: "pc",
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
        window.open(
          this.riverWarnConfig.pdfPath +
            info.type +
            "/" +
            info.code +
            "_" +
            Util.formatDate24(info.annTime, "YYYYMMDDHHmm") +
            "_" +
            info.annNo +
            "_" +
            info.docType +
            "_" +
            info.id +
            ".pdf",
          "_self"
        );
      }
    },
    /** タイトル判定 */
    jadgeTitle(type) {
      if (type === "fldfr") {
        return this.text.fldfrTitle;
      } else if (type === "evstg") {
        return this.text.evstgTitle;
      } else if (type === "damdsch") {
        return this.text.damdschTitle;
      } else if (type === "fldctl") {
        return this.text.fldctlTitle;
      }
      return "";
    },
    /** 種別名・背景・文字色判定 */
    jadgeKnd(info) {
      if (info.type === "evstg" || info.type === "fldfr") {
        if (info.lvl === 90) {
          return this.kndInfo[0];
        } else if (info.lvl === 80) {
          return this.kndInfo[1];
        } else if (info.lvl === 60) {
          return this.kndInfo[2];
        } else if (info.lvl === 30) {
          return this.kndInfo[3];
        }
      } else if (info.type === "damdsch") {
        if (info.lvl === 70) {
          return this.kndInfo[4];
        } else if (info.lvl === 50) {
          return this.kndInfo[5];
        } else if (info.lvl === 0) {
          return this.kndInfo[6];
        }
      } else if (info.type === "fldctl") {
        if (info.lvl === 40) {
          return this.kndInfo[7];
        } else if (info.lvl === 20) {
          return this.kndInfo[8];
        } else if (info.lvl === 10) {
          return this.kndInfo[9];
        }
      }
      return this.kndInfo[10];
    },
    /** 日時文字列変換 */
    getDateText(info) {
      return info.annTime == null
        ? ""
        : Util.formatDate24(info.annTime) + " 第" + info.annNo + "号";
    },
    getRwItemIndex(rwItemList, rwItem) {
      let indexList = [];
      for (var item of rwItemList) {
        indexList.push(item.id);
      }
      let index = indexList.indexOf(rwItem.id);
      return index;
    },
  },
  watch: {
    appTimeRound() {
      this.getObsRiverWarnRwInfo();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
